import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Flex, Box } from '@elparking/components'
import { ButtonRounded, FilterNumber } from '../../../ui/FilterButton'
import { getActiveFilters } from '../../../util/chargingPointFilter'
import {
    CHARGING_POINT_SPEED_FILTER,
    CHARGING_POINT_PLUG_TYPE_FILTER,
} from 'commons/js/constants'

const FilterBar = ({ activeFilter, filters, onToggleFilter }) => (
    <Flex flex={['1 1 100%']} flexWrap='wrap' justifyContent='start' w='100%'>
        <Box mr='0.5em'>
            <ButtonRounded
              onClick={() => { onToggleFilter(activeFilter === CHARGING_POINT_SPEED_FILTER ? null : CHARGING_POINT_SPEED_FILTER) }}
              fontWeight='book'
              height='34px'
              padding='0 16px'
              borderRadius='25px'
              fontSize='xxSmall'
              selected={activeFilter === CHARGING_POINT_SPEED_FILTER}
            >
                <FormattedMessage defaultMessage='Tipos de carga' />
                {getActiveFilters(filters.chargingPointSpeed)
                    ? <FilterNumber>{getActiveFilters(filters.chargingPointSpeed)}</FilterNumber>
                    : null
                }
            </ButtonRounded>
        </Box>
        <Box>
            <ButtonRounded
              onClick={() => { onToggleFilter(activeFilter === CHARGING_POINT_PLUG_TYPE_FILTER ? null : CHARGING_POINT_PLUG_TYPE_FILTER) }}
              fontWeight='book'
              height='34px'
              padding='0 16px'
              borderRadius='25px'
              fontSize='xxSmall'
              selected={activeFilter === CHARGING_POINT_PLUG_TYPE_FILTER}
            >
                <FormattedMessage defaultMessage='Conectores' />
                {getActiveFilters(filters.chargingPointPlugType)
                    ? <FilterNumber>{getActiveFilters(filters.chargingPointPlugType)}</FilterNumber>
                    : null
                }
            </ButtonRounded>
        </Box>
    </Flex>
)

FilterBar.propTypes = {
    filters: PropTypes.object,
    activeFilter: PropTypes.string,
    onToggleFilter: PropTypes.func,
}

FilterBar.defaultProps = {
    filters: {},
    onToggleFilter: () => {},
}

export default FilterBar
